import cx from 'classnames';

import { Image } from '~/components/Image';

interface Props {
  alt: string;
  src: string;
  radiusClass?: string;
}

const PostImage = ({ alt, radiusClass, src }: Props) => {
  return (
    <div className={cx('w-full overflow-hidden', radiusClass || 'rounded-wt')}>
      <Image src={src} alt={alt} maxWidth={800} loading={'eager'} aspectRatio="social" />
    </div>
  );
};

export default PostImage;
